import { render, staticRenderFns } from "./EditCooperationManagement.vue?vue&type=template&id=16e31741&scoped=true"
import script from "./EditCooperationManagement.vue?vue&type=script&lang=js"
export * from "./EditCooperationManagement.vue?vue&type=script&lang=js"
import style0 from "./EditCooperationManagement.vue?vue&type=style&index=0&id=16e31741&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e31741",
  null
  
)

export default component.exports